import api from "./apiService";

export const getQuestionList = (data) => api().post(`/admin/getQuestionList`, data).then(response => response); 

export const getQuestionDetails = (id) => api().get(`/admin/getQuestion/${id}`).then(response => response); 

const services = {
    getQuestionDetails,
    getQuestionList
}

export default services;